export default class ListItem {
  constructor(
    public id: string,
    public name: string,
    public subName: string,
    public isSelected: boolean,
    public isValid: boolean,
    public invalidReason: string
  ) { }
}